const PIXELFLOW_API_KEY = import.meta.env.VITE_PIXELFLOW_API_KEY;
const PIXELFLOW_SITE_ID = import.meta.env.VITE_PIXELFLOW_SITE_ID;
const PIXELFLOW_SCRIPT_URL = 'https://slrgkgulru.pixelflow.so/pfm.js';
const PIXELFLOW_API_ENDPOINT = 'https://api.pixelflow.so/event';

export type PixelFlowSignupMethod = 'email' | 'google' | 'microsoft';

type PixelFlowFunction = ((...args: unknown[]) => void) & {
  q?: unknown[][];
  l?: number;
  apiKey?: string;
  siteId?: string;
  apiEndpoint?: string;
};

const isPixelFlowEnabled = () =>
  import.meta.env.VITE_ENV === 'production' && !!PIXELFLOW_API_KEY && !!PIXELFLOW_SITE_ID;

const ensurePixelFlow = () => {
  if (typeof window.pixelFlow !== 'function') {
    const pixelFlow = ((...args: unknown[]) => {
      (pixelFlow.q = pixelFlow.q || []).push(args);
    }) as PixelFlowFunction;

    pixelFlow.l = Date.now();
    pixelFlow.apiKey = PIXELFLOW_API_KEY;
    pixelFlow.siteId = PIXELFLOW_SITE_ID;
    pixelFlow.apiEndpoint = PIXELFLOW_API_ENDPOINT;

    // pfm.js reads window.PixelFlowObject to locate the command queue.
    window.PixelFlowObject = 'pixelFlow';
    window.pixelFlow = pixelFlow;

    const script = document.createElement('script');
    script.async = true;
    script.src = PIXELFLOW_SCRIPT_URL;

    const firstScript = document.getElementsByTagName('script')[0];
    if (firstScript?.parentNode) {
      firstScript.parentNode.insertBefore(script, firstScript);
    } else {
      document.head.appendChild(script);
    }
  }

  return window.pixelFlow;
};

export const initPixelFlow = () => {
  if (!isPixelFlowEnabled()) {
    return;
  }

  const pixelFlow = ensurePixelFlow();
  if (typeof pixelFlow === 'function') {
    pixelFlow('track', 'PageView');
  }
};

export const trackPixelFlowPageView = () => {
  if (!isPixelFlowEnabled() || typeof window.pixelFlow !== 'function') {
    return;
  }

  window.pixelFlow('track', 'PageView');
};

export const trackPixelFlowSignupCompleted = (method: PixelFlowSignupMethod) => {
  if (!isPixelFlowEnabled() || typeof window.pixelFlow !== 'function') {
    return;
  }

  window.pixelFlow('track', 'CompleteRegistration', { method });
};
